/**
 * Always make sure to be complient with google policies when using.
 * @see https://developers.google.com/maps/documentation/places/web-service/policies
 * @see https://cloud.google.com/maps-platform/terms/maps-service-terms
 */
import {
    IGoogleMapsPlacesAutocompleteRequest,
    IGoogleMapsPlacesAutocompleteResponse,
    IGoogleMapsPlacesPlaceDetailsRequest,
    IGoogleMapsPlacesPlaceDetailsResult,
} from '@/features/google-places/google-places-types'

export const asyncRequestGoogleAutocompletePlacePredictions = (
    request: IGoogleMapsPlacesAutocompleteRequest
): Promise<IGoogleMapsPlacesAutocompleteResponse> => {
    // The Maps JS API is only present once the user consented to / activated Google Maps. Guard so
    // no request is attempted (and nothing throws) while `google` is undefined.
    if (typeof google === 'undefined') return Promise.resolve({ predictions: [] })

    return new google.maps.places.AutocompleteService().getPlacePredictions(request)
}

export const asyncRequestGoogleAutocompletePlace = (
    request: IGoogleMapsPlacesPlaceDetailsRequest,
    element?: HTMLDivElement | google.maps.Map
): Promise<IGoogleMapsPlacesPlaceDetailsResult | null> => {
    if (typeof google === 'undefined') return Promise.resolve(null)

    return new Promise((resolve, reject) => {
        new google.maps.places.PlacesService(element || document.createElement('div')).getDetails(
            request,
            (results, status) => {
                if (status !== 'OK') {
                    reject(status)
                } else {
                    resolve(results)
                }
            }
        )
    })
}
